export default __webpack_public_path__ + "static/media/pantry1-afterD-1440w.cc64708a.webp";